import { RegisterLifterCompetitionTypeSelect } from './register-result-competition-type';
import { RegisterLifterAgeCategorySelect } from './register-result-age-category';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from '../query-schema';

interface Props {
  isTeamComp?: boolean;
}

export function RegistrationListFilter({ isTeamComp = false }: Props) {
  const { register, setValue, values } = useFilterForm(querySchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på lyftare..." />

      {/* Team comps have no per-lifter competition type or age category to filter by. */}
      {/* Controlled with '' (not undefined) so picking the placeholder resets the displayed option. */}
      {!isTeamComp && (
        <RegisterLifterCompetitionTypeSelect
          onChange={event => setValue('competition_type_id', event.target.value)}
          value={values.competition_type_id ?? ''}
          placeholder="Alla tävlingstyper"
        />
      )}

      {!isTeamComp && (
        <RegisterLifterAgeCategorySelect
          onChange={event => setValue('age_category_id', event.target.value)}
          value={values.age_category_id ?? ''}
          placeholder="Alla ålderskategorier"
        />
      )}
    </Table.Bar>
  );
}
